module.exports = __webpack_public_path__ + "static/fonts/turboicons.cb539f2.cb539f2.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@hfe/turbo-ui/dist/font/turboicons.cb539f2.eot
// module id = 1028
// module chunks = 0